import React, { useEffect, useState } from "react";
import ServicePage from "./Service.module.css";
import { NavLink, useParams } from "react-router-dom";
import defaultIMG from "../../../Assets/Banner/gstregistration.png";
import startup from "../../../Assets/Banner/gstregistration.png";
import gstregistration from "../../../Assets/Banner/gstregistration.png";
import MCA from "../../../Assets/Banner/gstregistration.png";
import incometax from "../../../Assets/Banner/gstregistration.png";
import gst from "../../../Assets/Banner/gstregistration.png";
import trademark from "../../../Assets/Banner/gstregistration.png";

const categoryImages = {
  startup_services: startup,
  registrations: gstregistration,
  mca: MCA,
  income_tax_services: incometax,
  gst_services: gst,
  trademark_services: trademark,
  all_services: defaultIMG,
};

const Services1 = ({ serviceUrl }) => {
  const { name } = useParams();
  const [imageSrc, setImageSrc] = useState(defaultIMG);

  useEffect(() => {
    const normalizedCategoryName = name?.toLowerCase().replace(/\s+/g, "_");
    if (normalizedCategoryName && categoryImages[normalizedCategoryName]) {
      setImageSrc(categoryImages[normalizedCategoryName]);
    } else {
      setImageSrc(defaultIMG);
    }
  }, [name]);

  const finalImage = serviceUrl || imageSrc; // Prefer passed imageUrl if available

  return (
    <div className={ServicePage.Services1_container}>
      <div className={ServicePage.Services1div1_container}>
        <h1 className={ServicePage.Services1text}>Company Service</h1>
        <p className={ServicePage.text_container}>
          <ul>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Home
              </NavLink>
            </li>
            <span>|</span>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Company Service
              </NavLink>
            </li>
          </ul>
        </p>
      </div>
      <div className={ServicePage.Services1image_container}>
        <img
          src={finalImage}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultIMG;
          }}
          alt="service category"
          className={ServicePage.Services1Img}
        />
      </div>
    </div>
  );
};

export default Services1;
